import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const loginRequest = z.object({
	login: z.string(),
	password: z.string(),
	useJwt: z.boolean().or(z.number()).optional(),
	walletAddress: z.string().optional(),
	message: z.string().optional(),
	signature: z.string().optional(),
	phoneNumber: z.string().optional(),
	phoneCode: z.string().optional()
});

export type LoginRequest = z.infer<typeof loginRequest>;

export const loginResult = baseApiResponse.extend({
	data: z.object({
		result: z.object({
			loggedIn: z.string(),
			tradingURL: z.string()
			// jwtToken: z.string(),
			// refreshToken: z.string()
		})
	})
});

export type LoginResult = z.infer<typeof loginResult>;

export const loginCheckResult = baseApiResponse.extend({
	result: z.object({
		loggedIn: z.number()
	})
});

export type LoginCheckResult = z.infer<typeof loginCheckResult>;

export const refreshTokenResult = baseApiResponse.extend({
	result: z.object({
		jwtToken: z.string(),
		refreshToken: z.string()
	})
});

export type RefreshTokenResult = z.infer<typeof refreshTokenResult>;

export const confirmEmailByCodeResolver = baseApiResponse.omit({ data: true }).extend({
	data: z.object({
		result: z.boolean(),
		jwtToken: z.string(),
		refreshToken: z.string()
	})
});

export type ConfirmEmailByCodeResult = z.infer<typeof confirmEmailByCodeResolver>;

export const logoutResult = baseApiResponse.extend({
	result: z.object({
		loggedIn: z.string()
	})
});

export type LogoutResult = z.infer<typeof logoutResult>;

export const validateResetPasswordCodeResult = baseApiResponse.extend({
	data: z.object({
		code: z.string(),
		email: z.string(),
		time: z.number()
	})
});

export type ValidateResetPasswordCodeResult = z.infer<typeof validateResetPasswordCodeResult>;
